<template>
	<div class="simulation-game">
		<div class="simulation-item">
			<h4 class="simulation-title" style="color: #50FDFF;">我参加的比赛：</h4>
			<div class="competition-list" v-if="myCompetition.length">
				<div class="competition-item" v-for="(item, index) in myCompetition" :key="index">
					<div class="competition-name">{{item.exam_ground_name}}</div>
					<div class="competition-startDate">开始时间：{{new Date(item.start_time).format("yyyy.MM.dd HH:mm")}}</div>
					<div class="competition-endDate">结束时间：{{new Date(item.end_time).format("yyyy.MM.dd HH:mm")}}</div>
					<div class="competition-duration">比赛时长：{{item.use_time}}</div>
					<div class="competition-score" v-if="item.user_status == 8 && item.score !== null && item.score !== undefined">考试分数：{{item.score}}分</div>
					<img class="competition-img" v-if="item.user_status == 4" src="@/assets/img/simulationGame/yijieshu.png" alt="">
					<div class="competition-btn type1" v-if="item.user_status == 1" @click="showPopupPrompt(item, 3, true)">进入比赛
						<!-- <br><span>({{new Date().getTime()>new Date(item.user_status).getTime()?'已开始':'未开始'}})</span> -->
					</div>
					<div class="competition-btn type5" v-else-if="item.user_status == 2" @click="showPopupPrompt(item, 3, true)">继续比赛</div>
					<div class="competition-btn type3" v-else-if="item.user_status == 3" @click="showPopupPrompt(item, 4, true)">已交卷</div>
					<div class="competition-btn type4" v-else-if="item.user_status == 4" @click="showPopupPrompt(item, 0, true)">查看结果</div>
					<div class="competition-btn type4" v-else-if="item.user_status == 6" @click="showPopupPrompt(item, 5, true)">已交卷</div>
					<div class="competition-btn type4" v-else-if="item.user_status == 8" @click="showPopupPrompt(item, 8, true)">重新考试</div>
					<div class="competition-btn type4" v-else @click="showPopupPrompt(item, 0, true)">未知状态</div>
				</div>
			</div>
			<div class="no-data competition-item" v-else>暂未参加任何比赛</div>
		</div>
		<div class="simulation-item">
			<h4 class="simulation-title" style="color: #50FF69;">进行中的比赛：</h4>
			<div class="competition-list" v-if="inProgressCompetition.length">
				<div class="competition-item" v-for="(item, index) in inProgressCompetition" :key="index">
					<div class="competition-name">{{item.exam_ground_name}}</div>
					<div class="competition-startDate">开始时间：{{new Date(item.start_time).format("yyyy.MM.dd HH:mm")}}</div>
					<div class="competition-endDate">结束时间：{{new Date(item.end_time).format("yyyy.MM.dd HH:mm")}}</div>
					<div class="competition-duration">比赛时长：{{item.use_time}}</div>
					<div class="competition-btn type2" v-if="[1, 2].includes(item.real_status)" @click="showPopupPrompt(item, 1, false)">
						报名</div>
					<div class="competition-btn type2" v-else-if="item.real_status == 3" @click="showPopupPrompt(item, 2, false)">
						报名<br><span>(比赛中)</span></div>
				</div>
			</div>
			<div class="no-data competition-item" v-else>暂无进行中的比赛</div>
		</div>
		<div class="simulation-item">
			<h4 class="simulation-title" style="color: #FF5151;">已经结束的比赛：</h4>
			<div class="competition-list" v-if="endedCompetition.length">
				<div class="competition-item" v-for="(item, index) in endedCompetition" :key="index">
					<div class="competition-name">{{item.exam_ground_name}}</div>
					<div class="competition-startDate">开始时间：{{new Date(item.start_time).format("yyyy.MM.dd HH:mm")}}</div>
					<div class="competition-endDate">结束时间：{{new Date(item.end_time).format("yyyy.MM.dd HH:mm")}}</div>
					<div class="competition-duration">比赛时长：{{item.use_time}}</div>
					<img class="competition-img" src="@/assets/img/simulationGame/yijieshu.png" alt="">
					<div class="competition-btn type4" @click="showPopupPrompt(item, 0, false)">查看结果</div>
				</div>
			</div>
			<div class="no-data competition-item" v-else>暂无结束的比赛</div>
		</div>

		<!-- 弹窗提示 -->
		<popup-prompt ref="prompt" :title="pp.title" :message="pp.message" :showCancelBtn="pp.showCancelBtn"
			@confirm="confirm">
			<div style="text-align: left;width: 100%;padding-left: 55px;">
				<p>{{pp.cTitle}}</p>
				<p>开始时间：{{pp.startDate}}</p>
				<p>结束时间：{{pp.endDate}}</p>
				<p>比赛时长：{{pp.duration}}</p>
			</div>
		</popup-prompt>
	</div>
</template>

<script>
	const ppType = [{
		title: "确认报名",
		message: "报名后请按时参加比赛，错过比赛将按0分处理",
		showCancelBtn: true
	}, {
		title: "确认报名",
		message: "比赛进行中，报名后请及时进入赛场进行答题",
		showCancelBtn: true
	}, {
		title: "已报名",
		message: "比赛尚未开始，请按时参加比赛",
		showCancelBtn: false
	}, {
		title: "已交卷",
		message: "已交卷，请等待比赛结束后公布成绩",
		showCancelBtn: false
	}, {
		title: "比赛结束",
		message: "比赛结束，请等待公布成绩",
		showCancelBtn: false
	}, {
    title: "确认报名",
    message: "比赛进行中，报名后请及时进入赛场进行答题",
    showCancelBtn: true
  }, {
    title: "确认重新考试",
    message: "本次考试分数已统计完成，确认后将重新申请加入考试，并再次进入考试",
    showCancelBtn: true
  }, {
    title: "确认重新考试",
    message: "本次考试分数已统计完成，确认后将重新申请加入考试，并再次进入考试",
    showCancelBtn: true
  }]
	import popupPrompt from "@/components/popupPrompt";
	import {
		getExamGroundList,
		application,
		examGroundStatus,
    getTime
	} from '@/api/simulationGame'
	export default {
		name: "SimulationGame",
		components: {
			popupPrompt
		},
		data() {
			return {
				pp: {
					title: "提示",
					message: "",
					showCancelBtn: true,
					cTitle: "夏令营入营摸底考试",
					startDate: "",
					endDate: "",
					duration: ""
				},
				myCompetition: [],
				inProgressCompetition: [],
				endedCompetition: [],
				competitionClickId: "",
        competitionClickInfo: null,
        nowTime: ''
			}
		},
		created() {
		  this.getExamGroundList()
		},
		mounted() {},
		watch: {},
		filters: {},
		computed: {},
		methods: {
			async getExamGroundList() {
				let res = await getExamGroundList({chooseProblemType: 2});
				if (res.status) {
					this.myCompetition = res.data.joinExamGround
					this.inProgressCompetition = res.data.startExamGround
					this.endedCompetition = res.data.endExamGround
				}
			},
			/**
			 * @param {Object} info 比赛信息
			 * @param {Number} type 类型 0.已结束；1.报名(比赛未开始)；2.报名(比赛进行中)；3.进入比赛；4.已交卷
			 */
			async showPopupPrompt(info, type, status) { // 显示弹窗
				let nType = type;
				if(status){
					let res = await examGroundStatus({examGroundId: info.id});
					let typeArr = [3,3,4,0,0,5,7,8];
					nType = typeArr[res.data.status - 1];
					let examGroundInfo = this.myCompetition.find(a => a.id == info.id);
					examGroundInfo.user_status = res.data.status;
          if (res.data.score !== undefined) {
            examGroundInfo.score = res.data.score;
          }
				}
				if (nType == 0) {
				  if(info.open_rank == 1){
            let openRankDate = new Date(info.open_rank_time)
            let nowTime = await getTime()
            let nowDate = new Date(nowTime.data.time.date)
            if(openRankDate.getTime() <= nowDate.getTime()){
              this.showResult(info) // 查看结果
              return false
            }
          }
          this.pp = {
            title: ppType[4].title,
            message: ppType[4].message,
            showCancelBtn: ppType[4].showCancelBtn,
            cTitle: info.exam_ground_name,
            startDate: info.start_time,
            endDate: info.end_time,
            duration: info.use_time
          }
          this.competitionClickId = info.id
          this.competitionClickInfo = info
          this.$refs.prompt.open(4);
				} else if (nType == 3) {
					this.engageInAExam(info) // 进入比赛
				} else {
					this.pp = {
						title: ppType[nType - 1].title,
						message: ppType[nType - 1].message,
						showCancelBtn: ppType[nType - 1].showCancelBtn,
						cTitle: info.exam_ground_name,
						startDate: info.start_time,
						endDate: info.end_time,
						duration: info.use_time
					}
					this.competitionClickId = info.id
          this.competitionClickInfo = info
					this.$refs.prompt.open(nType);
				}
			},
			showResult(info) { // 查看结果
				this.$router.push({
					name: "competitionResult",
					query: {
						examGroundId: info.id
					}
				})
			},
			engageInAExam(info) { // 进入比赛
				this.$router.push({
					name: "competition",
					query: {
						examGroundId: info.id
					}
				})
			},
			confirm(type) { // 弹窗点击确定
				if (type == 1 || type == 2 || type == 8) { // 报名参赛 / 重新考试
					application({
						examGroundId: this.competitionClickId
					}).then(res => {
						if(res.status){
              if (type == 8) {
                this.$message.success("已重新加入考试，正在进入考场");
                this.engageInAExam(this.competitionClickInfo || { id: this.competitionClickId });
              } else {
							  this.$message.success("报名成功，请及时进入比赛");
              }
							this.getExamGroundList();
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.simulation-game {

		.simulation-item {
			.simulation-title {
				font-size: 1.12rem;
				font-family: "Source Han Sans SC";
				font-weight: 500;
				padding-left: 1.5rem;
				margin-bottom: 0.72rem;
			}

			.no-data {
				color: #FFF;
				font-size: 1.2rem;
				padding-left: 3rem;
				margin-bottom: 3rem;
			}

			.competition-list {
				font-size: 0.84rem;
				font-family: "Source Han Sans SC";
				font-weight: 500;
				color: #FFF;
				display: flex;
				flex-wrap: wrap;

				.competition-item {
					width: 13.5rem;
					height: 8rem;
					border-radius: 0.6rem;
					margin: 0 2rem 1.6rem 1.5rem;
					background-image: url(~@/assets/img/simulationGame/card-bg.png);
					background-size: cover;
					background-repeat: no-repeat;
					background-position: center;
					padding: 0.72rem 1.2rem 0.96rem;
					line-height: 1.5rem;
					position: relative;

					.competition-name,
					.competition-startDate,
					.competition-endDate,
					.competition-duration,
          .competition-score {
						position: relative;
						z-index: 2;
					}

          .competition-score {
            color: #FFE27A;
            font-size: 0.74rem;
          }

					.competition-img {
						width: 6.4rem;
						height: 5rem;
						position: absolute;
						top: 1.44rem;
						right: 1.6rem;
					}

					.competition-btn {
						font-size: 0.8rem;
						line-height: 0.8rem;
						width: 5rem;
						height: 1.6rem;
						border-radius: 10px;
						position: absolute;
						right: 1.2rem;
						bottom: 0.96rem;
						cursor: pointer;
						display: flex;
						justify-content: center;
						align-items: center;
						flex-direction: column;

						span {
							font-size: 0.6rem;
							line-height: 0.6rem;
						}
					}

					// 进入比赛
					.type1 {
						background: #00D49B;
					}

					// 报名
					.type2 {
						background: #0FB63A;
					}

					// 已交卷
					.type3 {
						background: #FF5C5C;
					}

					// 查看结果
					.type4 {
						background: #00AAD4;
					}

					// 继续比赛
					.type5 {
						background: #FF8B31;
					}
				}
			}
		}
	}
</style>
